<template>
  <div class="date-range-picker d-flex flex-row flex-wrap align-baseline">
    <date-picker
        field-class="mb-2"
        v-model="value.startDate"
        :max="value.endDate"
        :clearable="startDateClearable"
        @change="changed"/>
    <span class="mb-2 pl-2 pr-2 font-weight-bold">-</span>
    <date-picker
        field-class="mb-2"
        v-model="value.endDate"
        :clearable="endDateClearable"
        :min="value.startDate"
        @change="changed"/>
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker';

export default {
  name: 'DateRangePicker',
  components: { DatePicker },
  props: {
    value: {
      type: Object,
      required: true,
      validate(value) {
        return value.startDate && value.endDate;
      },
    },
    startDateClearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    endDateClearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    changed() {
      this.$emit('input', this.value);
      this.$emit('change');
    },
  },
};
</script>

<style scoped>

</style>
